export const getUrlParams = () => new URLSearchParams(window.location.search);

export const getUrlParam = (name: string) => {
	const params = getUrlParams();
	if (params.has(name)) {
		return params.get(name);
	}
	return null;
};
